/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GovernorateEnum } from './GovernorateEnum';
import {
    GovernorateEnumFromJSON,
    GovernorateEnumFromJSONTyped,
    GovernorateEnumToJSON,
} from './GovernorateEnum';

/**
 * 
 * @export
 * @interface ClinicInfoOut
 */
export interface ClinicInfoOut {
    /**
     * 
     * @type {number}
     * @memberof ClinicInfoOut
     */
    id?: number;
    /**
     * 
     * @type {GovernorateEnum}
     * @memberof ClinicInfoOut
     */
    governorate?: GovernorateEnum;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    clinicLicenseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    phoneNumber1?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    phoneNumber2?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    district?: string;
    /**
     * 
     * @type {string}
     * @memberof ClinicInfoOut
     */
    street?: string;
}

/**
 * Check if a given object implements the ClinicInfoOut interface.
 */
export function instanceOfClinicInfoOut(value: object): boolean {
    return true;
}

export function ClinicInfoOutFromJSON(json: any): ClinicInfoOut {
    return ClinicInfoOutFromJSONTyped(json, false);
}

export function ClinicInfoOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClinicInfoOut {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'governorate': json['governorate'] == null ? undefined : GovernorateEnumFromJSON(json['governorate']),
        'clinicLicenseNumber': json['clinic_license_number'] == null ? undefined : json['clinic_license_number'],
        'taxNumber': json['tax_number'] == null ? undefined : json['tax_number'],
        'phoneNumber1': json['phone_number1'] == null ? undefined : json['phone_number1'],
        'phoneNumber2': json['phone_number2'] == null ? undefined : json['phone_number2'],
        'address': json['address'] == null ? undefined : json['address'],
        'district': json['district'] == null ? undefined : json['district'],
        'street': json['street'] == null ? undefined : json['street'],
    };
}

export function ClinicInfoOutToJSON(value?: ClinicInfoOut | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'governorate': GovernorateEnumToJSON(value['governorate']),
        'clinic_license_number': value['clinicLicenseNumber'],
        'tax_number': value['taxNumber'],
        'phone_number1': value['phoneNumber1'],
        'phone_number2': value['phoneNumber2'],
        'address': value['address'],
        'district': value['district'],
        'street': value['street'],
    };
}

